<template>
    <v-overlay
        :z-index="10"
        :value="alert.showLoading"
        align="center"
    >
        <v-progress-circular
            indeterminate
            size="64"
            color="primary"
        >
        </v-progress-circular>

        <div class="mt-4">{{alert.messageLoading}}</div>
    </v-overlay>
</template>

<script>
import {mapState} from 'vuex'
export default {
    data() {
        return{
        }
    },
    computed: {
        ...mapState({alert: state => state.alerts})
    }
}
</script>
